import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Agency from '../entities/agency';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import Airport from '../entities/airport';

interface AirportState extends ListState<Airport> {}

class FlightMutations extends ListMutations<Airport> {}

class AirportModule {
  namespaced = true;
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Airport>(),
    fromAirportlist: new Array<Airport>(),
    toAirportlist: new Array<Airport>(),
    loading: false,
  };
  actions = {
    async getAirports(context, payload: any) {
      context.state.loading = true;

      const response = await Ajax.get(
        '/api/services/app/Flight/GetAirportsForAutoComplete'
      );
      return response;
    },
    async getFromAirports(context, payload: any) {
      context.state.loading = true;
      const response = await Ajax.post(
        '/api/services/app/Flight/SearchAirport',
        payload.data
      );
      context.state.loading = false;
      const page = response.data;
      context.state.totalCount = page.totalCount;
      context.state.fromAirportlist = page.result;
    },
    async getToAirports(context, payload: any) {
      context.state.loading = true;

      const response = await Ajax.post(
        '/api/services/app/Flight/SearchAirport',
        payload.data
      );
      context.state.loading = false;
      const page = response.data;
      context.state.totalCount = page.totalCount;
      context.state.toAirportlist = page.result;
    },
    init(context, payload: any) {},
  };
  mutations = {
    setCurrentPage(state, page: number) {
      state.currentPage = page;
    },
    setPageSize(state, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const airportModule = new AirportModule();
export default airportModule;
